"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CACHE_KEYS = void 0;
var CACHE_KEYS;
(function (CACHE_KEYS) {
    CACHE_KEYS[CACHE_KEYS["SUBPLEBBIT_IPNS"] = 0] = "SUBPLEBBIT_IPNS";
    CACHE_KEYS[CACHE_KEYS["INTERNAL_SUBPLEBBIT"] = 1] = "INTERNAL_SUBPLEBBIT";
    CACHE_KEYS[CACHE_KEYS["POSTS_SUBPLEBBIT"] = 2] = "POSTS_SUBPLEBBIT";
    // Prefixes have to start with PREFIX and end with _
    CACHE_KEYS[CACHE_KEYS["PREFIX_TRIGGER_COMMENT_UPDATE_"] = 3] = "PREFIX_TRIGGER_COMMENT_UPDATE_";
    CACHE_KEYS[CACHE_KEYS["PREFIX_COMMENT_REPLIES_"] = 4] = "PREFIX_COMMENT_REPLIES_";
})(CACHE_KEYS = exports.CACHE_KEYS || (exports.CACHE_KEYS = {}));
